import { CircleAlert } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/src/components/shadcn/ui/alert";

export function WorkflowStepInformationNeeded({ note }: { note: string | null | undefined }) {
  return (
    <Alert className="border-warn/30 bg-warn/10">
      <CircleAlert className="size-4" />
      <AlertTitle>Information needed</AlertTitle>
      <AlertDescription className="whitespace-pre-wrap">
        {note || "Resolve the missing information before resuming this step."}
      </AlertDescription>
    </Alert>
  );
}
